import { RESTClient } from '@api/client';
import { CreateCohortType } from '@dynamika-shared/types/cohorts';

export const createCohort = (id: string, body: CreateCohortType) => {
    return RESTClient.post(`clinical-trials/${id}/cohorts`, body);
};

export const updateCohort = (ctId: string, cohortId: string, body: CreateCohortType) => {
    return RESTClient.put(`clinical-trials/${ctId}/cohorts/${cohortId}`, body);
};
export const deleteCohort = (ctId: string, cohortId: string) => {
    return RESTClient.delete(`clinical-trials/${ctId}/cohorts/${cohortId}`);
};

